import React from 'react';
import { Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { PageSectionTitle } from 'src/components/enterprise/layout/PageSectionTitle/PageSectionTitle';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { SftpWarningMessage } from 'src/components/enterprise/features/Employee/components/Form/SftpWarningMessage/SftpWarningMessage';
import { DepartmentsSelectSearchControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/DepartmentsSelectSearchControlWrapper/DepartmentsSelectSearchControlWrapper';
import { LocationsSelectSearchControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/LocationsSelectSearchControlWrapper/LocationsSelectSearchControlWrapper';
import { SsoIdentifierWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/SsoIdentifierWrapper/SsoIdentifierWrapper';
import { FirstNameControl } from 'src/components/common/FirstNameControl/FirstNameControl';
import { LastNameControl } from 'src/components/common/LastNameControl/LastNameControl';
import { EmailControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/EmailControlWrapper/EmailControlWrapper';
import { BasePhoneNumberInput } from 'src/components/common/BasePhoneNumberInput/BasePhoneNumberInput';
import { InternalIdControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/InternalIdControlWrapper/InternalIdControlWrapper';
import { SubDepartmentControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/SubDepartmentControlWrapper/SubDepartmentControlWrapper';

export const EmployeeInformation: React.FC = () => {
  return (
    <Stack y="md">
      <PageSection>
        <SftpWarningMessage />
        <Stack y="sm">
          <PageSectionTitle title="Employee Information" />
        </Stack>
        <Row>
          <Column phone={12}>
            <Stack y="sm">
              <Row gutter={12}>
                <Column phone={4} gutter={12}>
                  <FirstNameControl name="firstName" id="firstName" />
                </Column>
                <Column phone={4} gutter={12}>
                  <LastNameControl name="lastName" id="lastName" />
                </Column>
              </Row>
            </Stack>
            <Stack y="sm">
              <Row gutter={12}>
                <Column phone={4} gutter={12}>
                  <EmailControlWrapper />
                </Column>
                <Column phone={4} gutter={12}>
                  <BasePhoneNumberInput name="phoneNumber" id="phoneNumber" />
                </Column>
              </Row>
            </Stack>
            <Stack y="sm">
              <Row gutter={12}>
                <Column phone={4} gutter={12}>
                  <DepartmentsSelectSearchControlWrapper />
                </Column>
                <Column phone={4} gutter={12}>
                  <SubDepartmentControlWrapper />
                </Column>
              </Row>
            </Stack>
            <Row gutter={12}>
              <Column phone={4} gutter={12}>
                <LocationsSelectSearchControlWrapper />
              </Column>
              <Column phone={4} gutter={12}>
                <InternalIdControlWrapper />
              </Column>
              <Column phone={4} gutter={12}>
                <SsoIdentifierWrapper />
              </Column>
            </Row>
          </Column>
        </Row>
      </PageSection>
    </Stack>
  );
};
